// tokenGenerator.js
import jsSHA from 'jssha';

function base64UrlEncode(str) {
  return btoa(JSON.stringify(str))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');
}

function createSignature(encodedHeader, encodedPayload, secret) {
  const shaObj = new jsSHA('SHA-512', 'TEXT');
  shaObj.setHMACKey(secret, 'TEXT');
  shaObj.update(`${encodedHeader}.${encodedPayload}`);
  const hmac = shaObj.getHMAC('B64');

  return hmac.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

export function generateToken() {
  const now = Math.floor(Date.now() / 1000);
  const expiryTime = now + 15 * 60;

  const payload = {
    PHPSESSID: '103c1bb38cf6901bb0dc8248df82cf83',
    exp: expiryTime,
    iat: now
  };

  const header = {
    alg: 'HS512',
    typ: 'JWT'
  };

  const encodedHeader = base64UrlEncode(header);
  const encodedPayload = base64UrlEncode(payload);
  const key = process.env.SECRET_KEY_GENERATE_JWT;

  const signature = createSignature(encodedHeader, encodedPayload, key);

  return `${encodedHeader}.${encodedPayload}.${signature}`;
}
